import { getData } from '../utils/data.js';
export const ClientType = {
    User: 'user',
    Group: 'group',
};
export const ClientStatus = {
    Active: 'active',
    Inactive: 'inactive',
};
export const ClientPlan = {
    Free: 'free',
    Pro: 'pro',
};
export const ClientApplicationStatus = {
    Applied: 'applied',
    Approved: 'approved',
    Rejected: 'rejected',
    Banned: 'banned',
    Accepted: 'accepted',
};
export const createGroupClient = (name, iconURL, ownerId, address) => {
    const now = new Date();
    return {
        clientMemberIds: [ownerId],
        ownerMemberId: ownerId,
        createdMemberId: ownerId,
        createdAt: now,
        updatedAt: now,
        status: ClientStatus.Active,
        plan: ClientPlan.Free,
        name: name,
        iconURL: iconURL,
        type: ClientType.Group,
        applicationStatus: ClientApplicationStatus.Approved,
        address: address,
    };
};
export const createUserClientFromInput = (input) => {
    const now = new Date();
    return {
        clientMemberIds: [input.id],
        ownerMemberId: input.id,
        createdMemberId: input.id,
        createdAt: now,
        updatedAt: now,
        status: ClientStatus.Active,
        plan: ClientPlan.Free,
        name: input.name,
        iconURL: input.iconURL,
        type: ClientType.User,
        applicationStatus: ClientApplicationStatus.Approved,
        address: input.address,
    };
};
export const clientConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
//# sourceMappingURL=client.js.map